<template>
  <div>
    <div class="row mt-3">
      <div class="col-sm">
        <button type="button" class="btn btn-primary" @click="getProducts">GET random products</button>
        <button type="button" class="btn btn-secondary" @click="products=pedidos=[]">Limpiar array de products</button>
        <button type="button" class="btn btn-secondary" @click.prevent="obtenerPersonaje(1)">Test api ext</button>
        
        <button type="button" class="btn btn-secondary" @click="getProductsTrierre">Products T</button>
        <button type="button" class="btn btn-primary" @click="getUserDetails">getUserDetails con token</button>
        <button type="button" class="btn btn-primary" @click="getPedidos">getPedidos con api_token</button>
        
        
        <p v-for="(item, index) in pedidos" :key="item.id">
          {{ item.id}}, {{item.nombre}}, {{item.fecha}}. <span @click="getGeocode(index)">{{item.direccion}}, {{item.localidad}}, {{item.codigo_postal}}, {{item.provincia}}</span>
        </p>

        <p v-for="item in products" :key="item.id" @click="select(item)">
          {{ item.name}}, {{item.id}}
        </p>

      </div>
      <div class="col-sm">
        <router-view></router-view>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm">
        <div class="form-group">
          <label for="exampleInputEmail1">Prueba LocalStorage</label>
          <input type="text" class="form-control" id="storage" v-model="textoAlmacenado">
        </div>

        <button type="button" class="btn btn-secondary" @click.prevent="almacenarTexto">Guardar</button>
        <button type="button" class="btn btn-secondary" @click.prevent="recuperarTexto">Recuperar</button>
      </div>
    </div>
    
  </div>
</template>

<script>
import {authHeader} from '@/_helpers/_auth-header';
// import store from 'store/simplestore';
import $ from 'jquery'; // para test de swapi
import axios from 'axios';
import {userService} from '@/_services/user.service';


export default {
  data() {
    return {
      products: [],
      productsTrierre: [],
      pedidos: [],
      textoAlmacenado: '',
      notificacion: false
    }
  },
  methods: {
    getProducts() {
      let url = this.$store.state.urlBase + '/api/product-ran';
      // let url = 'http://api-test.test/api/product-ran';

      // Via axios
      // axios.get(url)
      //   .then(function(response) {
      //       console.log(response.data);
      //       let result = response.data;
      //       this.products = result.data;
      //   }.bind(this))
      //   .catch(function(error) {
      //       console.log(error)
      //   });
      
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };

      // via fetch
      fetch(url, requestOptions)
        .then(response => response.json())
        .then(json => {
          console.log('estoy en fetch');
          console.log(json);
          let result = json;
          this.products = result.data;
          // desactivo, antiguo store
          // store.state.products = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    
    getProductsTrierre() {
      let url = 'http://gestion.trierre.es/api/v1/invoices';
      let options = {
        headers: {
          // 'X-Ninja-Token': 'ekmvvckwdqdqzcchagqrbjgnmtfkpt11',
          'X-Ninja-Token': 'cvkx4rzhdhjz4kw6anli04wp1mdpfmiq', // empresa prueba ACME
          'crossDomain': true,
          'Access-Control-Allow-Origin': '*',
          'Content-Type' : 'application/json',
          },
      }

      // Via axios
      axios.get(url,options)
        .then(response => {
            console.log(response.data);
            let result = response.data;
            this.productsTrierre = result.data;
        })
        .catch(error => {
            console.log(error)
        });

    },

    select(product) {
      console.log(product.id);
      this.$router.push('/apiprueba/' + product.id);
    },

    obtenerPersonaje(id) {
      const API_URL = 'https://swapi.co/api/';
      const PEOPLE_URL = 'people/:id';
      const url = `${API_URL}${PEOPLE_URL.replace(':id',id)}`;
      const opts = {crossDomain: true};

      $.get( url, opts, (persona) => {
        console.log(`Hola ${persona.name}`);
      })
    },

    almacenarTexto() {
      localStorage.setItem("textoAlmacenado", this.textoAlmacenado);
      if (this.products) {
        localStorage.setItem("products", JSON.stringify(this.products));
      }
      console.log('Texto guardado en localStorage')
    },
    recuperarTexto() {
      let texto = localStorage.getItem("textoAlmacenado");
      console.log(texto);
      this.textoAlmacenado = texto;
      this.products = JSON.parse(localStorage.getItem("products"));
    },

    getUserDetails() {
      let url = this.$store.state.urlBase + '/api/auth/user';
      let options = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          },
      };
      axios.get(url,options)
        .then(response => {
          console.log(response);
          if (response.data) {
            localStorage.setItem('userDetails', JSON.stringify(response.data));
          }

        })
        .catch(error => {
          console.log(error);
        })
    },

    getPedidos() {
      let url = this.$store.state.urlBase + '/api/v3/1/pedidos';
      let options = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          },
      };
      axios.get(url,options)
        .then(response => {
          console.log(response);
          if (response.data.data) {
            console.log('pedidos ok');
            console.log('data.data:',response.data.data);
            this.pedidos = response.data.data.data;
          }

        })
        .catch(userService.handleErrorResponseAxios);
    },

    getGeocode(index) {
      let direccion = [
        this.pedidos[index].direccion, 
        this.pedidos[index].localidad, 
        this.pedidos[index].codigo_postal, 
        this.pedidos[index].provincia
        ].join(',')
      console.log('direccion: ',direccion);
      let url = 'https://maps.googleapis.com/maps/api/geocode/json';
      let params = {
        key: 'AIzaSyAal7_QwpdkdUQoIbxwPwyKNH2h6MMC1wk',
        address: direccion
      }

      // Via axios
      axios.get(url, { params })
        .then(function(response) {
            console.log(response.data);
            let result = response.data;
            this.result = result;
            
            if (result.status == 'OK') {
              console.log('resultado correcto')
              
            } else {
              // this.coordenadas = null;
            }
        }.bind(this))
        .catch(function(error) {
            console.log(error)
        });

    },
  },
  mounted() {
    // this.textoAlmacenado = localStorage.getItem("textoAlmacenado");
  },
  activated() {

  }
}
</script>

